import { makeStyles } from '@mui/styles';
import { Colors } from '../../ui/theme/colors';

export const usePermissionsStyles = makeStyles(() => ({
  card: {
    backgroundColor: 'white',
    padding: '5px'
  },
  granted: {
    color: Colors.collectedGreen
  },
  denied: {
    color: Colors.cancelledDeletedRed
  },
  table: {
    fontSize: '16px'
  }
}));
